import { render, staticRenderFns } from "./TepTurnoDetalle.vue?vue&type=template&id=4921fa8c"
import script from "./TepTurnoDetalle.vue?vue&type=script&lang=js"
export * from "./TepTurnoDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports